import { Component } from '@angular/core';

@Component({
  selector: 'hbo-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent {

}
